import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/checkbox.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import { hot } from 'react-hot-loader/root'
import Masthead from '@ta-interaktiv/react-masthead'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import './styles.scss'
import { Cover } from 'components/cover'
import { VerticalSegment } from 'components/verticalSegment'
import { Footer } from 'components/footer'
import { SubmitForm } from 'components/submitForm'
import { Questions } from 'components/questions'
import { Rules } from 'components/rules'
import { LocaleContext } from '../../contexts/locale'
import { Statistics } from 'components/statistics'
import AppPromo from '../apppromotion/index.js'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Waypoint } from 'react-waypoint'

import config from 'config'

// For some reasons, these things have to be declared here, because otherwise
// they won't be picked up for some reason?
declare global {
  interface Window {
    project: {
      version: string
      buildTimestamp: number
    }

    // TODO: move this to a more appropriate package
    dataLayer?: { event: string; event_action?: string; event_label?: string }[]
  }
}

/** Article ID */
const ARTICLE_ID = config.articleId

function AppComponent() {
  const [locale, setLocale] = useState<'de' | 'fr' | 'en'>('de')
  const [publicationDate, setPublicationDate] = useState<number>(
    window.project.buildTimestamp
  )
  const domain = parseHostname().publicationDomain

  useEffect(() => {
    // Download publication date
    window
      .fetch(`https://m.${domain}/api/articles/${ARTICLE_ID}`)
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(`${response.status}: ${response.statusText}`)
      })
      .then(data => {
        setPublicationDate(data.article.first_published_at)
      })
      .catch(e => {
        console.groupCollapsed('Main')
        console.warn('API Access failed: ', e)
        console.groupEnd()
      })

    // Download language
    window
      .fetch(`https://m.${domain}/api/sites/default`)
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(response.status.toString())
      })
      .then(data => {
        setLocale(data.site.language)
      })
      .catch(error => {
        console.warn(error)
      })
  }, [domain, ARTICLE_ID])

  return (
    <div className='index'>
      <LocaleContext.Provider value={locale}>
        <ThemeSwitch />
        <Masthead articleId={ARTICLE_ID} inverted />
        <Cover
          onLeave={event => {
            if (
              event.previousPosition === Waypoint.inside &&
              event.currentPosition === Waypoint.above
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'startReading'
              })
            }
          }}
        />

        <VerticalSegment className='inverted basic' text>
          <Rules />
        </VerticalSegment>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: '25ContentRead'
              })
            }
          }}
        />

        <Statistics />

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'contentBottom'
              })
            }
          }}
        />

        <Footer articleId={ARTICLE_ID} publicationDate={publicationDate} />

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'pageBottom'
              })
            }
          }}
        />
      </LocaleContext.Provider>
    </div>
  )
}

export const App = hot(AppComponent)
